import { isDefined } from 'common/helpers'
import type { Nullable } from 'common/types'
import { select } from 'd3'
import type { FC } from 'react'
import { useEffect, useId, useState } from 'react'

import { DEFAULT_HISTOGRAM_THICKNESS, GRADIENT_OFFSET } from '../constants'
import { useLegendContext } from '../context'
import type { HistogramProps } from '../types'
import { useGradientDefs } from '../useGradientDefs'
import { DefaultHistogram } from './DefaultHistogram'
import { createHistogramPath } from './helpers'

// Только для вертикальной легенды
export const Histogram: FC<HistogramProps> = ({
  histogramIntervals,
  histogramThickness = DEFAULT_HISTOGRAM_THICKNESS,
}) => {
  const id = useId()
  const [containerEl, setContainerEl] = useState<Nullable<SVGGElement>>(null)
  const { height, entityId, palette } = useLegendContext()

  useEffect(() => {
    if (!isDefined(histogramIntervals)) return

    const container = select(containerEl)
    const path = createHistogramPath(container, id, histogramThickness, height, histogramIntervals)

    return () => {
      path.remove()
    }
  }, [containerEl, histogramThickness, height, id, histogramIntervals])

  useGradientDefs(id, containerEl, palette)

  if (!isDefined(entityId)) {
    return <DefaultHistogram width={histogramThickness} height={height - GRADIENT_OFFSET} />
  }

  if (!isDefined(histogramIntervals)) return

  return <svg ref={setContainerEl} width={histogramThickness} height={height} />
}
